import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { APIList } from 'src/interfaces'
import { Entities } from 'src/enums'
import { VerizonReport } from 'src/api'
import { useApiInstance } from './useApiInstance'
import {
  buildRequestParams,
  ObjectType,
  transformPage,
  transformPerPage,
} from './helpers'

interface RequestParams {
  params?: Partial<AdminVerizonReportsGetParams>;
  paramsTransform?: Array<(params: Record<string, any>) => Record<string, any>>;
  options?: Omit<
    UseQueryOptions<unknown, Error, APIList<VerizonReport>>,
    'queryKey' | 'queryFn'
  >;
}

interface AdminVerizonReportsGetParams {
  limit: number;
  offset: number;
  search: string;
}

const schema: ObjectType['schema'] = {
  limit: 'number',
  offset: 'number',
  search: 'string',
}

export const useVerizonReportsListRequest = ({
  params = {},
  paramsTransform = [],
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  const transformedParams = [
    transformPerPage,
    transformPage,
    ...paramsTransform,
  ].reduce((param, transform) => transform(param), params)

  const queryParams = buildRequestParams<AdminVerizonReportsGetParams>(
    transformedParams,
    schema,
  )

  return useQuery<unknown, Error, APIList<VerizonReport>>(
    [Entities.Sensors, JSON.stringify(transformedParams)],
    async () => {
      const {
        limit,
        offset,
        search,
      } = queryParams
      const { data } = await api.v1AdminVerizonReportsGet(
        limit,
        offset,
        search,
      )
      return data
    },
    options,
  )
}
